import React from 'react';

export const HouseLine = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 174">
      <g fill="none" fillRule="evenodd" stroke="#03ADC4" strokeWidth="2.676">
        <path d="M2.005 80.11L78.883 2l75.639 76.809m-48.36-65.092h26.04v29.942M2.005 133.734c7.44-8.782 20.666-13.173 39.679-13.173 28.52 0 48.359 23.712 73.158 23.712 16.533 0 29.76-7.026 39.68-21.077M2.005 161.631c7.44-8.782 20.666-13.173 39.679-13.173 28.52 0 48.359 23.712 73.158 23.712 16.533 0 29.76-7.026 39.68-21.078"></path>
        <path d="M66.223 45.24h24.082v25.107H66.223z"></path>
      </g>
    </svg>
  );
};
